<script setup>
import { ref, computed } from "vue";
import HeaderCalendar from "../components/ui/HeaderCalendar.vue";
import RowInput from "../components/ui/RowInput.vue";
import { useStore } from "@/stores";

import { useRouter } from "vue-router";

const store = useStore().rows;
const router = useRouter();
const currentWeekMonday = ref(new Date());

const getMonday = (d) => {
  d = new Date(d);
  var day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -6 : 1);
  return new Date(d.setDate(diff));
};

// Start with correct Monday
currentWeekMonday.value = getMonday(new Date());

const weekId = computed(() => {
  // Use ISO string YYYY-MM-DD as key
  const offset = currentWeekMonday.value.getTimezoneOffset();
  const date = new Date(currentWeekMonday.value.getTime() - offset * 60 * 1000);
  return date.toISOString().split("T")[0];
});

const weekDays = computed(() => store.getWeek(weekId.value));

const handleLogout = () => {
  router.push("/");
};
</script>

<template>
  <div class="container mx-auto p-6 space-y-8">
    <div class="flex justify-between items-center">
      <HeaderCalendar v-model:date="currentWeekMonday" />
      <button
        @click="handleLogout"
        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-700"
      >
        Tancar Sessió
      </button>
    </div>

    <div class="grid grid-cols-1 gap-6">
      <RowInput
        v-for="(day, index) in weekDays"
        :key="weekId + '-' + index"
        :day="day"
        :dayIndex="index"
        :weekId="weekId"
      />
    </div>
  </div>
</template>
